import { render, staticRenderFns } from "./tabInternalServiceRecordOfSchool.vue?vue&type=template&id=2605f957&"
import script from "./tabInternalServiceRecordOfSchool.vue?vue&type=script&lang=ts&"
export * from "./tabInternalServiceRecordOfSchool.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports